import { config } from "../app.configs";
import { getAPIURL, getCachedBusiness, setTokenExpiry } from "./utils";
import { useRouter } from "next/router";

export function handleLogin(email, password) {
  return fetch(getAPIURL("users/token/"), {
    method: "POST",
    body: JSON.stringify({ email, password }),
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  }).then((res) => {
    if (res.ok) {
      return res.json().then((json) => {
        setTokenExpiry(json.expires_in);
        Promise.resolve(json);
      });
    }
    return res.json().then((json) => Promise.reject(json));
  });
}

export const isPegInstalled = () => {
  if (typeof window === 'undefined') return false;
  const installedPegs = JSON.parse(window.localStorage.getItem(`${getCachedBusiness()}_installed_pegs`)) || [];
  return installedPegs.includes('space');
}

export function withActiveToken(call, router) {
  const tokenExpiryDate = getTokenExpiry();
  if (tokenExpiryDate === null) {
    if (router.pathname !== '/home' && router.pathname !== '/[uuid]/home') {
      // router.push('/login');
      handlelogOut(router);
      return;
    } else {
      router.push('/');
    }
  }

  

  if (isTokenExpired(tokenExpiryDate)) {
    return refreshToken()
      .then((json) => {
        setTokenExpiry(json.expires_in);

        call();
      })
      .catch((err) => {
        // handlelogOut();
        router.push('/')
      });
  } else {
    call();
  }
}

export const isStaging = () => {
  const isLocal = typeof window !== 'undefined' && window.location.hostname.startsWith('local');
  const isStagingEnv = typeof window !== 'undefined' && window.location.hostname.startsWith('staging');
  return isStagingEnv || isLocal;
}

export function isTokenExpired(tokenExpiryDate) {
  const time_now = new Date().getTime();
  const expiry_time = new Date(tokenExpiryDate).getTime();

  return time_now > expiry_time;
}

export function getTokenExpiry() {
  const cookieName = "tokenExpiry";
  const cookieString = document.cookie;
  const cookies = cookieString.split(';');

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    // Check if this cookie is the one we're looking for
    if (cookie.indexOf(cookieName + '=') === 0) {
      return cookie.substring(cookieName.length + 1) || null;
    }
  }

  return null;
}

export function refreshToken(call) {
  return fetch(getAPIURL("users/token/refresh/"), {
    method: "POST",
    credentials: "include",
  }).then((res) => {
    if (res.ok) {
      return res.json().then(json => {
        setTokenExpiry(json.expires_in);
        return json;
      });
    }
    return res.json().then((json) => Promise.reject(json));
  });
}

export function prefix() {
  return process.env.NEXT_PUBLIC_BRANCH ? `${process.env.NEXT_PUBLIC_BRANCH}.` : "";
}

export function handleLogoutRedirect(router, page, ignoreEp) {
  window.location.href = `http://${prefix()}accounts.workpeg.com/${page}?peg=space&ep=${ignoreEp ? '' : router.asPath}`;
}

export function handlelogOut(router) {
  return fetch(getAPIURL("users/token/"), {
    method: "DELETE",
    credentials: "include",
  }).then((res) => {
    if (res.ok) {
      clearCookies();
      localStorage.removeItem("tokenExpiry");
      // window.location.href = `/login`;
      handleLogoutRedirect(router, 'login');
    }
  });
}

export function getRandomPassword(length = 18) {
  const uppercaseChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const lowercaseChars = "abcdefghijklmnopqrstuvwxyz";
  const numberChars = "0123456789";
  const specialChars = "!@#$%^&*()-_+=[]{}|;:,.<>?";

  const allChars = uppercaseChars + lowercaseChars + numberChars + specialChars;

  return Array.from(
    { length },
    () => allChars[Math.floor(Math.random() * allChars.length)]
  ).join("");
}

export function isProtectedRoute(route) {
  const unProtectedRoutes = config.unProtectedRoutes;
  return !unProtectedRoutes.includes(route);
}

export const sentMagicLink = (email, additionalData) => {
  return fetch(getAPIURL("users/token/magic-links/"), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email, ...additionalData }),
  }).then((res) => {
    if (res.ok) {
      return res.json().then((json) => {
        Promise.resolve(json);
      });
    }
    return res.json().then((json) => Promise.reject(json));
  });
};

export const logout = async () => {
  return fetch(getAPIURL("users/token/"), {
    method: "DELETE",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  }).then((res) => {
    if (res.ok) {
      clearCookies();
      return Promise.resolve(res);
    }
  });
};

export const clearCookies = () => {
  const domain = window.location.hostname;
  const cookies = document.cookie.split(';');

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    const cookieName = cookie.split('=')[0];
    document.cookie = `${cookieName}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT;`;
    document.cookie = `${cookieName}=; path=/; domain=${domain}; expires=Thu, 01 Jan 1970 00:00:00 GMT;`;

    if (domain.indexOf('.') !== -1) {
      const rootDomain = domain.substring(domain.indexOf('.'));
      document.cookie = `${cookieName}=; path=/; domain=${rootDomain}; expires=Thu, 01 Jan 1970 00:00:00 GMT;`;
    }
  }
  // Immediately remove the cookies by setting their expiry to a past date
  document.cookie = "tokenExpiry=; domain=.workpeg.com; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Strict";
  document.cookie = `csrftoken=; path=/; domain=${domain};`;
  document.cookie = `sessionid=; path=/; domain=${domain};`;
};
